export const EMPTY_OBJ = {};
export const EMPTY_ARR = [];
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const NOOP = (): void => {};
